/**
 * Paywall - shown when the free execution limit is reached.
 * Paid plans are suspended (21/10/2026): the modal only informs, with no prices.
 */

import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';
import { SubscriptionStatus } from '../types';

interface PaywallProps {
  open: boolean;
  status: SubscriptionStatus | null;
  onUpgrade: () => void;
  onClose: () => void;
}

const Paywall: React.FC<PaywallProps> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Free limit reached</DialogTitle>
    <DialogContent>
      <Typography color="text.secondary">
        You have used the free executions available. Paid plans are currently unavailable.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default Paywall;
